import React from 'react';

import { isValidSelector } from '../../../../../services/validators/selectors/selectors';
import { DeselectedMenuItemAction, SelectedSubmenuItemAction } from '../../../../actions/menuActions';
import { useStudentSelector } from '../../../../store/selectors/useStudentSelector';
import { ItemDetailsType, MenuItem, MenuItemProps } from '../../components/student/MenuItem';
import { MenuItem as MenuItemModel, TrackingStatus } from '@ael/core-api';
import { useDispatch } from 'react-redux';

interface OwnProps {
  item: MenuItemModel;
  trackingStatus?: TrackingStatus;
  children: React.ReactNode;
  expanded: boolean;
  parentItemId: string | null;
  hasActiveChild: boolean;
  nestedLevel: number;
  isLinearModeOn: boolean;
}

export const SubmenuItem: React.FC<OwnProps> = (ownProps) => {
  const isValid = useStudentSelector(isValidSelector);
  const dispatch = useDispatch();
  const props: MenuItemProps = {
    ...ownProps,
    menuItemDetails: {
      active: ownProps.expanded,
      itemDetailsType: ItemDetailsType.Submenu,
      hasActiveChild: ownProps.hasActiveChild,
      trackingStatus: ownProps.trackingStatus,
      disabled: !isValid(ownProps.item),
      parentItemId: ownProps.parentItemId,
      nestedLevel: ownProps.nestedLevel,
      itemId: ownProps.item.id,
    },
    onClick: () => {
      dispatch(
        ownProps.expanded || ownProps.hasActiveChild
          ? DeselectedMenuItemAction(ownProps.item)
          : SelectedSubmenuItemAction(ownProps.item, ownProps.parentItemId)
      );
    },
  };

  return <MenuItem {...props} />;
};
